import Link from 'next/link';
import useAuth from 'src/shared-components/Auth';
import Avatar from 'src/shared-components/Avatar';

interface CustomerOnboardingTaskProps {
  text: string;
  link?: string;
  newTab?: boolean;
  optional?: boolean;
  onClick?: () => void;
  icon?: React.ReactNode;
  disableOnComplete?: boolean;
}

const DEFAULT_COMPANY_AVATAR = process.env.DEFAULT_COMPANY_AVATAR || '';

const CustomerOnboardingTask = (props: CustomerOnboardingTaskProps) => {
  const { link, newTab, onClick, text } = props;
  const { user } = useAuth();
  return (
    <LinkContainer link={link} newTab={newTab}>
      <div className="hover:cursor-pointer" onClick={onClick}>
        <div className="flex  drop-shadow min-w-full bg-[#E5E5E4] text-black rounded-lg p-2 w-12/12 h-40 items-center">
          {/* {icon ? icon : <div className="rounded-full bg-huddlePink w-6 h-6 m-4"></div>} */}

          <div className="ml-10 shadow-md border-[8px] -rotate-6 bg-[#FCE1B9] border-white rounded-[10px] flex justify-center items-center">
            <Avatar
              size={'sm'}
              image={user.companies[0]?.photoUrl || DEFAULT_COMPANY_AVATAR}
              className="w-full h-full rounded-none"
            />
          </div>

          <div className="md:flex">
            <div className="text-xl ml-5">{text + ' '} </div>
            <div className="underline text-xl sm: ml-5 lg:ml-1 md:ml-1  whitespace-nowrap">Lets do it.</div>
          </div>
        </div>
      </div>
    </LinkContainer>
  );
};

const LinkContainer = ({ children, link, newTab }: { children: React.ReactChild; link?: string; newTab?: boolean }) => {
  if (link)
    return (
      <Link href={link} passHref>
        <a target={newTab ? '_blank' : '_self'}>{children}</a>
      </Link>
    );
  return <div>{children}</div>;
};

export default CustomerOnboardingTask;
